"use strict";

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/classCallCheck");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var browser_1 = __importDefault(require("./browser"));
var mobile_apps_1 = __importDefault(require("./mobile-apps"));
var feed_readers_1 = __importDefault(require("./feed-readers"));
var libraries_1 = __importDefault(require("./libraries"));
var media_players_1 = __importDefault(require("./media-players"));
var personal_information_managers_1 = __importDefault(require("./personal-information-managers"));
var clientParsers = [feed_readers_1.default, mobile_apps_1.default, media_players_1.default, personal_information_managers_1.default, browser_1.default, libraries_1.default];
var ClientParser = /*#__PURE__*/_createClass(function ClientParser(options) {
  var _this = this;
  _classCallCheck(this, ClientParser);
  this.options = {
    versionTruncation: 1
  };
  this.parse = function (userAgent) {
    for (var _i = 0, _clientParsers = clientParsers; _i < _clientParsers.length; _i++) {
      var Parser = _clientParsers[_i];
      var parser = new Parser(_this.options);
      var client = parser.parse(userAgent);
      if (client.type !== "") return client;
    }
    return null;
  };
  this.options = Object.assign(Object.assign({}, this.options), options);
});
exports.default = ClientParser;